var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      height: "100%"
    }
  }, [_c("a-card", {
    staticClass: "addsuccess_card"
  }, [_c("div", {
    staticStyle: {
      "max-width": "500px",
      margin: "40px auto 0",
      "text-align": "center"
    }
  }, [_c("result", {
    attrs: {
      title: _vm.$t("public.addSuccessfully"),
      "is-success": true
    }
  }), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.addNewActivity
    }
  }, [_vm._v(_vm._s(_vm.$t("public.newagain")))]), _c("a-button", {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      click: _vm.release
    }
  }, [_vm._v(_vm._s(_vm.$t("public.returntolist")))])], 1)]), _c("a-modal", {
    attrs: {
      title: _vm.$t("activity.selecttype"),
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.typeVisible,
      callback: function callback($$v) {
        _vm.typeVisible = $$v;
      },
      expression: "typeVisible"
    }
  }, [_c("a-form-model", {
    ref: "dataTypeForm",
    attrs: {
      model: _vm.typeValue,
      rules: _vm.typeRules
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("activity.type"),
      prop: "activityType"
    }
  }, [_c("a-select", {
    model: {
      value: _vm.typeValue.activityType,
      callback: function callback($$v) {
        _vm.$set(_vm.typeValue, "activityType", $$v);
      },
      expression: "typeValue.activityType"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("activity.unitdiscount")) + " ")]), _c("a-select-option", {
    attrs: {
      value: 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("activity.doublepoints")) + " ")]), _c("a-select-option", {
    attrs: {
      value: 3
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("activity.specialoffer")) + " ")])], 1)], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        return _vm.resetType();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.cancel")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.finish
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.determine")))])], 1)], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };